import React from "react";
import NotFoundPageComponent from "./notFoundPage.component";

const NotFoundPageContainer = () => {
  return <NotFoundPageComponent />;
};

export default NotFoundPageContainer;
